/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createImageUploadResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type ImageUploadResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/images/from-local
 */
export interface FromLocalRequestBuilder extends BaseRequestBuilder<FromLocalRequestBuilder> {
    /**
     * Stores the image and assigns it to what the Sku (or, with ExtractSkuFromImageName, the file name) names: the product with that SKU or image name, else the product family with that key, whose shared images it joins. The response says which, and reports `none` when nothing matched and the image was only stored.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ImageUploadResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ImageUploadResponse | undefined>;
    /**
     * Stores the image and assigns it to what the Sku (or, with ExtractSkuFromImageName, the file name) names: the product with that SKU or image name, else the product family with that key, whose shared images it joins. The response says which, and reports `none` when nothing matched and the image was only stored.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FromLocalRequestBuilderUriTemplate = "{+baseurl}/api/images/from-local";
/**
 * Metadata for all the requests in the request builder.
 */
export const FromLocalRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: FromLocalRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createImageUploadResponseFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
